interface RequestTitleProps {
  title: string
}

export const RequestTitle = ({ title }: RequestTitleProps) => {
  return (
    <h1 className="text-2xl text-[var(--brand-blue-3)] font-bold">{title}</h1>
  )
}
